"use client";

// @ts-strict-ignore
import React, { useState } from "react";
import { useMedia } from "react-use";
import { mediaQuery, Flex, Text, Button } from "@hubble/web";
import { useInlineCTAData } from "utils/context";
import Picture from "components/parts/Picture";
import styled from "styled-components";
import InstitutionsHubspotModal from "components/pages/Institutions/InstitutionsHubspotModal";
import { Colors } from "themes/color-palette";
import NextLink from "components/parts/NextLink";

const StyledPicture = styled(Picture)`
  img {
    margin: 0;
    max-height: 250px;
  }
  margin-top: 24px;
  display: block;
  ${({ theme: { media } }) => media.desktop`
    margin-left: 40px;
    margin-top: 0;
  `};
`;

const ContentfulInlineCTA = () => {
  const cta = useInlineCTAData();
  const { data } = cta;

  const [modalOpen, setModalOpen] = useState(false);
  const [ignorePageScroll, setIgnorePageScroll] = useState(false);
  const isTablet = useMedia(mediaQuery.tabletMdDown, false);
  const isMobile = useMedia(mediaQuery.mobileXsDown, false);

  const toggleIgnoreScroll = () => {
    !ignorePageScroll
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "unset");
    setIgnorePageScroll(!ignorePageScroll);
  };

  const openModal = () => {
    setModalOpen(true);
    toggleIgnoreScroll();
  };

  const closeModal = () => {
    setModalOpen(false);
    toggleIgnoreScroll();
  };

  if (!data) return null;

  const {
    image,
    tabletImage,
    buttonLink,
    buttonLabel,
    darkBackground,
    backgroundImage,
    header,
    body,
    hubspotFormId,
    modalSubtitle,
    modalTitle
  } = data;

  const ctaImage = isTablet && tabletImage ? tabletImage : image;

  return (
    <Flex
      justifyContent="space-between"
      flexDirection={isMobile ? "column" : "row"}
      backgroundColor={darkBackground ? Colors.black : Colors.gray[50]}
      backgroundImage={
        backgroundImage ? `url(${backgroundImage.fields.file.url})` : null
      }
      backgroundSize="cover"
      alignItems="center"
      p={3}
      m={0}
      mt={5}
      mb={5}
      borderRadius={"16px"}
    >
      <InstitutionsHubspotModal
        modalOpen={modalOpen}
        closeModal={closeModal}
        formId={hubspotFormId}
        modalTitle={modalTitle}
        modalSubtitle={modalSubtitle}
      />
      <Flex
        flexDirection="column"
        maxWidth={"340px"}
        textAlign={isMobile ? "center" : "left"}
        alignItems={isMobile ? "center" : "start"}
      >
        <Text.Heading>{header}</Text.Heading>
        <Text.Body>{body}</Text.Body>
        {Boolean(hubspotFormId) && (
          <Button.Primary size="md" onClick={openModal}>
            {buttonLabel}
          </Button.Primary>
        )}
        {Boolean(buttonLink) && !hubspotFormId && (
          <NextLink
            style={{ textDecoration: "none" }}
            newTab
            id="contentful-cta-link"
            href={buttonLink}
          >
            <Button.Primary size="lg" mt={0}>
              {buttonLabel}
            </Button.Primary>
          </NextLink>
        )}
      </Flex>
      {Boolean(image) && !backgroundImage && (
        <StyledPicture
          src={ctaImage.fields.file.url}
          alt={image.fields.title}
        />
      )}
    </Flex>
  );
};

export default ContentfulInlineCTA;
